import { render } from "./JejakAudit.vue?vue&type=template&id=2312a8eb&scoped=true"
import script from "./JejakAudit.vue?vue&type=script&lang=js"
export * from "./JejakAudit.vue?vue&type=script&lang=js"

import "./JejakAudit.vue?vue&type=style&index=0&id=2312a8eb&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2312a8eb"]])

export default __exports__